.currency-column-value {
  width: 100%;
  text-align: right;
}
